module.exports = __webpack_public_path__ + "static/media/1019503.8acc52d7.jpg";